import { Tab } from "@/components/ui/mobile-tab-switcher";
import { Eye, MessageCircle } from "lucide-react";

// Default tabs: Chat & Preview (always shown)
const TABS: Tab<"chat" | "preview">[] = [
  { value: "chat", label: "Chat", icon: MessageCircle },
  { value: "preview", label: "Preview", icon: Eye },
];

export { TABS };
